import { render, staticRenderFns } from "./ClientAnswerForDep.component.vue?vue&type=template&id=0008ce70&scoped=true&"
import script from "./ClientAnswerForDep.component.vue?vue&type=script&lang=js&"
export * from "./ClientAnswerForDep.component.vue?vue&type=script&lang=js&"
import style0 from "./ClientAnswerForDep.component.vue?vue&type=style&index=0&id=0008ce70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008ce70",
  null
  
)

export default component.exports